<template>
    <div :class="`flex ${wrap?'flex-wrap':'flex-nowrap'} ${direction}`" style="overflow-x:auto;">
        <div v-for="(data, index) in datas" :key="index" @click="onClick(data, index)"
            :class="{ 'tw-list-view-item-highlight': data === data_source.current }"
            style="margin-right: 8px;">
            <slot v-bind:data="data" v-bind:columns="data_source.columns" v-bind:index="index">
            </slot>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue'

export default {
    name: 'tw-list-view',
    props: {
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        // 是否高亮显示当前项
        highlightCurrent: {
            type: Boolean,
            default: false
        },
        direction: {
            type: String,
            default: 'flex-row'
        },
        wrap: {
            type: Boolean,
            default: true
        }
    },
    setup(props) {
        const designMode = window.site && window.site.designMode;

        const datas = computed(() => {
            let result = props?.data_source?.datas ?? []
            if (designMode && !result.length) {
                // 设计模式时需要增加一个空行用于设计插槽里的内容
                result = [{}]
            }
            return result
        })

        const onClick = function(data) {
            // eslint-disable-next-line vue/no-mutating-props
            props.data_source.current = data
        }

        return {
            datas,
            onClick
        }
    }
}
</script>

<style>

</style>